module.exports = { ...require('.') }